import React, { Component } from "react";
import '../rnr.css';
import Table from 'react-bootstrap/Table';
import { MathFormula } from '../libs/myUtils.js';

class Glossary extends Component {
  
  render() {
    return (
      <main className="flex-shrink-0">
        <div className="container">
            <h4 className="mt-3">Glossary</h4><br />
            <Table size="sm" borderless="true" hover>
                <tbody>
                    <tr>
                        <td colSpan="2"><h4>I</h4></td>
                    </tr>
                    <tr>
                        <td style={{width: "17%"}}><strong>Invariants</strong></td>
                        <td style={{width: "83%"}}>
                          <MathFormula string="Random shocks $\varepsilon_{t}$ that are independent and identically distributed (i.i.d.) across all time steps i.e. a white noise. The invariants determine the randomness of a data generating process. 
                          The invariants are extracted from the risk drivers by identifying and fitting the most suitable next step model." />
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="2"><h4>N</h4></td>
                    </tr>
                    <tr>
                        <td style={{width: "17%"}}><strong>Next Step Model</strong></td>
                        <td style={{width: "83%"}}>
                        <MathFormula string="A model/function that describes the future time step of a process $X_{t+1}$ as being comprised of known information $i_{t}$ (e.g. realized variables $x_{t}$) and unknown random shocks $\varepsilon_{t+1}$ (invariants). It incorporates only information known at the current time step and ideally, should be parsimonious in its 
                          specification and time-homogeneous i.e. the same at all time steps:" />
                        <MathFormula string="$$X_{t+1}|i_{t}= next\_step_{t \rightarrow t+1} (i_{t}, \varepsilon_{t+1})$$" />
                        <MathFormula string="$$next\_step_{t \rightarrow t+1}(\cdot,\cdot) = next\_step(\cdot,\cdot)$$" />
                        <p>Examples include the random walk, autogressive-moving average, GARCH and fractional integration models.</p>
                        </td>
                    </tr>

                    <tr>
                        <td colSpan="2"><h4>R</h4></td>
                    </tr>
                    <tr>
                        <td style={{width: "17%"}}><strong>Random Walk</strong></td>
                        <td style={{width: "83%"}}>
                          <MathFormula string="A process where the next step $X_{t+1}$ is given by the previous step $X_{t}$, plus a shock $\epsilon_{t+1}$ which is independent and identically distributed (i.i.d.) across all time steps.
                          Equivalently, the change in a random walk process is an invariant:" />
                          <MathFormula string="$$X_{t+1}=X_{t} + \epsilon_{t+1} \Leftrightarrow \Delta X_{t+1}=\epsilon_{t+1}$$" />
                            {/* <MathFormula string="Innovation function: $\epsilon_{t+1}=X_{t+1}-X_{t}$" /> */}
                            
                       </td>
                    </tr>
                    <tr>
                        <td style={{width: "17%"}}><strong>Risk Drivers</strong></td>
                        <td style={{width: "83%"}}>
                          <MathFormula string="Transformed raw financial data that are random variables $X_{t}$ which (i) display homogeneous behaviour across time, similar to a random walk and (ii) determine the P&L of the instrument:" />
                          <MathFormula string="$$X_{t} \approx X_{t-1} + iid\ shocks$$" />
                        </td>
                    </tr>

                </tbody>
           </Table>
        </div>
      </main>
    );
  }
}
 
export default Glossary;